import React from "react";
import Weather from "./Weather";

export default function WeatherAdvice(props) {
  return (
    <div>
      <a href="https://www.youtube.com/watch?v=ZxEHGAY7LbY" target="_blank">
        {" "}
        *Wear Sunscreen
      </a>
    </div>
  );
}
